export const TIMELINE_PARAMS_CONFIGS = {
	nbDays: process.env.TIMELINE_NB_DAYS || 120,
	nbTopResults: process.env.TIMELINE_NB_TOP_RESULTS || 10
}
